import {
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  filter,
  tap,
} from 'rxjs/operators';
import { OfferProduct } from '../../models/offer-product.model';
import { ProductService } from '../../services/product.service';
import { SearchOverlayService } from '../../services/search-overlay.service';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    CommonModule, 
    ReactiveFormsModule, 
    RouterModule 
  ],
  templateUrl: './search.html',
  styleUrls: ['./search.scss'],
})
export class Search {

  private readonly productService = inject(ProductService);
  private readonly overlayService = inject(SearchOverlayService);
  private fb = inject(FormBuilder);

  searchResult = signal<OfferProduct[]>([]);

  form: FormGroup = this.fb.group({
    search: ['', Validators.required],
  });

  showSearchOverlay = this.overlayService.showOverlay;

  constructor() {
    this.form
      .get('search')!
      .valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap((value) => {
          if (!value) this.searchResult.set([]);
        }),
        filter((value) => !!value),
        switchMap((searchText: string) => this.productService.searchProducts(searchText))
      )
      .subscribe((products) => this.searchResult.set(products));
  }

  onSearchFocus(): void {
    this.overlayService.showSearchOverlay();
  }

  onProductClick(): void {
    this.form.reset();
    this.overlayService.hideOverlay();
  }

  truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }
}